import React from 'react';
import type { MenuProps } from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  CarOutlined,
  InboxOutlined,
  EnvironmentOutlined,
  FileOutlined,
  BookOutlined,
  BarChartOutlined,
  SettingOutlined,
  DollarOutlined,
  ProfileOutlined,
  CalculatorOutlined,
  CalendarOutlined,
} from '@ant-design/icons';

type BuildMenuPermissions = {
  canViewFinance: boolean;
  canViewDocuments: boolean;
  canViewPOA: boolean;
  canViewAnalytics: boolean;
  canViewReferences: boolean;
  canViewReports: boolean;
  showAdmin: boolean;
};

export const buildMenuConfig = (permissions: BuildMenuPermissions): MenuProps['items'] => {
  const {
    canViewFinance,
    canViewDocuments,
    canViewPOA,
    canViewAnalytics,
    canViewReferences,
    canViewReports,
    showAdmin,
  } = permissions;

  const items: MenuProps['items'] = [];

  // ОСНОВНОЕ
  items.push({
    type: 'group',
    key: 'group-main',
    label: 'ОСНОВНОЕ',
    children: [
      {
        key: '/dashboard',
        icon: <DashboardOutlined />,
        label: 'Дашборд',
      },
      {
        key: '/workspace',
        icon: <DashboardOutlined />,
        label: 'Workspace',
      },
    ],
  });

  // ОПЕРАЦИИ
  items.push({
    type: 'group',
    key: 'group-operations',
    label: 'ОПЕРАЦИИ',
    children: [
      { key: '/applications', icon: <FileTextOutlined />, label: 'Заявки' },
      { key: '/routes', icon: <CarOutlined />, label: 'Маршруты' },
      { key: '/operations/driver-schedule', icon: <CalendarOutlined />, label: 'График водителей' },
      { key: '/cargo', icon: <InboxOutlined />, label: 'Грузы' },
      { key: '/warehouses', icon: <EnvironmentOutlined />, label: 'Склады' },
      { key: '/drivers-vehicles', icon: <CarOutlined />, label: 'Автопарк' },
    ],
  });

  // ДОКУМЕНТЫ
  items.push({
    type: 'group',
    key: 'group-documents',
    label: 'ДОКУМЕНТЫ',
    children: [
      ...(canViewDocuments
        ? [{ key: '/documents', icon: <FileOutlined />, label: 'Документооборот' }]
        : []),
      { key: '/tn', icon: <ProfileOutlined />, label: 'ТН' },
      { key: '/partner-applications', icon: <ProfileOutlined />, label: 'Заявки партнёра' },
      ...(canViewPOA ? [{ key: '/poa', icon: <ProfileOutlined />, label: 'Доверенности' }] : []),
    ],
  });

  // ФИНАНСЫ
  if (canViewFinance) {
    items.push({
      type: 'group',
      key: 'group-finance',
      label: 'ФИНАНСЫ',
      children: [
        { key: '/finance/workspace', icon: <DollarOutlined />, label: 'Finance Workspace' },
        { key: '/finance/invoices', icon: <DollarOutlined />, label: 'Счета' },
        { key: '/finance/payments', icon: <DollarOutlined />, label: 'Платежи' },
        { key: '/finance/receivables', icon: <DollarOutlined />, label: 'Дебиторка' },
        { key: '/finance/payables', icon: <DollarOutlined />, label: 'Кредиторка' },
      ],
    });
  }

  // АНАЛИТИКА
  items.push({
    type: 'group',
    key: 'group-analytics',
    label: 'АНАЛИТИКА',
    children: [
      ...(canViewAnalytics
        ? [{ key: '/analytics/cost', icon: <BarChartOutlined />, label: 'Аналитика стоимости' }]
        : []),
      { key: '/control/logists', icon: <BarChartOutlined />, label: 'Контроль логистов' },
      { key: '/control/carriers', icon: <BarChartOutlined />, label: 'Контроль перевозчиков' },
      { key: '/control/clients', icon: <BarChartOutlined />, label: 'Контроль клиентов' },
      ...(canViewReports
        ? [{ key: '/reports', icon: <BarChartOutlined />, label: 'Отчеты' }]
        : []),
    ],
  });

  // ИНСТРУМЕНТЫ
  items.push({
    type: 'group',
    key: 'group-tools',
    label: 'ИНСТРУМЕНТЫ',
    children: [
      { key: '/calculations', icon: <CalculatorOutlined />, label: 'Расчеты размещения' },
      { key: '/tools/delivery-cost', icon: <CalculatorOutlined />, label: 'Расчет стоимости' },
    ],
  });

  // СПРАВОЧНИКИ
  if (canViewReferences) {
    items.push({
      type: 'group',
      key: 'group-directories',
      label: 'СПРАВОЧНИКИ',
      children: [
        { key: '/references', icon: <BookOutlined />, label: 'Справочники' },
      ],
    });
  }

  // СИСТЕМА
  if (showAdmin) {
    items.push({
      type: 'group',
      key: 'group-system',
      label: 'СИСТЕМА',
      children: [
        { key: '/administration', icon: <SettingOutlined />, label: 'Администрирование' },
      ],
    });
  }

  return items;
};

